import { inject, onMounted, ref } from 'vue';
import SModalCentered from '@/components/stemdo-components/s-modal-centered/SModalCentered.vue';
import { useI18N } from '@/plugins/i18n';
import SButton from '../s-button/SButton.vue';
import PdfService from '@/sections/admin/entities/pdf/pdf.service';
import DocxService from '@/sections/admin/entities/docx/docx.service';
import { useStore } from '@/plugins/vuex';
import { is } from 'cypress/types/bluebird';

export default {
  props: {
    type: String as () => 'teamRequest' | 'stemdoer',
    required: true,
    id: {
      type: String,
      required: true
    },
    width: {
      type: Number,
      default: 650
    },
    onLinkCopied: {
      type: Function
    }
  },
  components: {
    SModalCentered,
    SButton
  },
  setup(props) {
    const i18n = useI18N();
    const store = useStore();
    const isModalOpen = ref(false);
    const link = ref('');
    const baseUrl = window.location.origin;
    const hide = ref(false);
    const openPopup = ref(false);
    const pdfService: PdfService = inject('pdfService');
    const isManager = store.getters.account?.authorities.includes('ROLE_GESTOR') ?? false;
    const isProfile = ref(false);
    const docxService: DocxService = inject('docxService');
    const loadingPdf = ref(false);
    const loadingDocx = ref(false);

    onMounted(() => {
      if (window.location.pathname.includes('team-requests') || window.location.pathname.includes('stemdoer')) {
        hide.value = false;
      }
    });

    const getTitle = () => {
      return props.type === 'teamRequest'
        ? i18n.t('s-external-link.title-tr').toString()
        : i18n.t('s-external-link.title-stemdoer').toString();
    };
    const openModal = () => {
      if (props.type === 'teamRequest') {
        link.value = baseUrl + `/team-requests/${props.id}`;
        isProfile.value = false;
      } else {
        link.value = baseUrl + `/stemdoer/${props.id}`;
        isProfile.value = true;
      }
      isModalOpen.value = true;
    };
    const copyLink = (isHide: boolean) => {
      window.focus();
      const linkToCopy = isHide ? `${link.value.toString()}?h` : link.value.toString();
      navigator.clipboard.writeText(linkToCopy);
      isModalOpen.value = false;
      props.onLinkCopied(true, i18n.t('s-external-link.copy-link').toString());
    };

    const downloadPdf = async (isAnonymous?: boolean) => {
      loadingPdf.value = true;
      try {
        if (props.type === 'stemdoer') {
          const blobPdf = await pdfService.downloadStemdoerPdf(props.id, isAnonymous);
          pdfService.handlePdfDownload(`stemdoer-${props.id}.pdf`, blobPdf);
          isModalOpen.value = false;
        } else if (props.type === 'teamRequest') {
          const blobPdf = await pdfService.downloadTeamRequestPdfFromTeamRequest(props.id, isAnonymous);
          pdfService.handlePdfDownload(`team-request-${props.id}.pdf`, blobPdf);
          isModalOpen.value = false;
        }
      } finally {
        loadingPdf.value = false;
      }
    };

    const downloadStemdoerDocx = async (isAnonymous?: boolean) => {
      loadingDocx.value = true;
      try {
        const blobDocx = await docxService.downloadStemdoerDocx(props.id, isAnonymous);
        docxService.handleDocxDownload(`stemdoer-${props.id}.docx`, blobDocx);
        isModalOpen.value = false;
      } catch (err) {
        console.error('Error downloading DOCX:', err);
      } finally {
        loadingDocx.value = false;
      }
    };

    return {
      isModalOpen,
      link,
      hide,
      openPopup,
      isManager,
      isProfile,
      openModal,
      getTitle,
      copyLink,
      downloadPdf,
      downloadStemdoerDocx,
      loadingPdf,
      loadingDocx
    };
  }
};
